import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store'

// Containers
import Full from '@/containers/Full'

// Views
import Login from '@/views/Login'
import Dashboard from '@/views/Dashboard'
import NotAuthorized from '@/views/NotAuthorized'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter: guest
    },
    {
      path: '/',
      redirect: 'dashboard',
      name: 'Home',
      component: Full,
      beforeEnter: auth,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'pos',
          redirect: 'pos',
          name: 'POS',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'product',
              name: 'Product',
              component: () => import('@/views/pos/product/Product')
            },
            {
              path: 'category',
              name: 'Category',
              component: () => import('@/views/pos/product/Category')
            },
            {
              path: 'transaction',
              name: 'Transaction',
              component: () => import('@/views/pos/transaction/Transaction')
            },
            {
              path: 'history',
              name: 'History',
              component: () => import('@/views/pos/transaction/History')
            }
          ]
        },
        {
          path: 'external',
          redirect: 'external',
          name: 'External',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'External Dashboard',
              component: Dashboard
            },
            {
              path: 'product',
              name: 'External Product',
              component: () => import('@/views/external/product/Product')
            },
            {
              path: 'category',
              name: 'External Category',
              component: () => import('@/views/external/product/Category')
            },
            {
              path: 'gallery',
              name: 'Gallery',
              component: () => import('@/views/external/gallery/Gallery')
            },
            {
              path: 'gallery/category',
              name: 'Gallery Category',
              component: () => import('@/views/external/gallery/Gallery')
            },
            {
              path: 'news',
              name: 'News',
              component: () => import('@/views/external/News')
            },
            {
              path: 'video',
              name: 'Video',
              component: () => import('@/views/external/Video')
            },
            {
              path: 'franchise',
              name: 'Franchise',
              component: () => import('@/views/external/Franchise')
            },
            {
              path: 'transaction',
              name: 'External Transaction',
              component: () => import('@/views/external/transaction/Transaction')
            },
            {
              path: 'history',
              name: 'External Transaction History',
              component: () => import('@/views/external/transaction/History')
            },
            {
              path: 'outlet',
              name: 'Outlet',
              component: () => import('@/views/external/Outlet')
            }
          ]
        },
        {
          path: 'console',
          name: 'Console',
          component: () => import('@/views/developer/Console')
        }
      ]
    },
    {
      path: '/not-authorized',
      name: 'NotAuthorized',
      component: NotAuthorized
    }
  ]
})

function auth (to, from, next) {
  const auth = store.getters.auth

  if (!auth.isLoggedIn && to.path !== '/login') {
    next('/login')
  } else {
    next()
  }
}

function guest (to, from, next) {
  const auth = store.getters.auth

  if (auth.isLoggedIn && to.path !== '/') {
    next('/')
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js